import { db, FirebaseDocRefType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { PointCardOfferType as BasicPointCardOfferType } from 'types/pointCard/pointCardOffer'

type PointCardOfferType = BasicPointCardOfferType & { ref: FirebaseDocRefType }

const PointCardOfferConverter = getConverter<PointCardOfferType>()

export const fetchPointCardOffer = (pointCardId: string, id: string): Promise<PointCardOfferType | undefined> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_offers')
    .doc(id)
    .withConverter(PointCardOfferConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return undefined
      }
      return {
        ...data,
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchPointCardOffers = (pointCardId: string): Promise<PointCardOfferType[]> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_offers')
    .withConverter(PointCardOfferConverter)
    .orderBy('created_at', 'asc')
    .get()
    .then((snapshots) =>
      snapshots.docs.map((snapshot) => {
        const data = snapshot.data()
        return {
          ...data,
          ref: snapshot.ref,
        }
      })
    )
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const setPointCardOffer = (pointCardOffer: PointCardOfferType): Promise<void> => {
  const { ref, ...rest } = pointCardOffer
  return ref.set(rest, { merge: true })
}

export const deletePointCardOffer = (pointCardId: string, id: string): Promise<void> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_offers')
    .doc(id)
    .delete()
    .catch((error) => {
      console.error(error)
    })
}
